import React from "react";
import styled from "@emotion/styled";
import PreviewSection from "../components/PreviewSection";
import CodeBlock from "../components/CodeBlock";
import { Divider } from "@atlas-int/ui";
import {
  spacing,
  fontSize,
  fontFamily,
  fontWeight,
  border as borderToken,
  brand,
  text,
} from "@atlas-int/tokens";

const Label = styled.span`
  display: inline-block;
  font-family: ${fontFamily.mono};
  font-size: ${fontSize.sm};
  font-weight: ${fontWeight.normal};
  color: ${text.muted};
  margin-bottom: ${spacing[2]};
`;

const ExampleBlock = styled.div`
  margin-bottom: ${spacing[8]};
`;

const DividerSection: React.FC = () => {
  return (
    <PreviewSection
      id="divider"
      title="Divider"
      description="A styled horizontal rule using the borderDivider token. Accepts an optional $color prop for custom colors."
    >
      <ExampleBlock>
        <Label>Default (borderDivider)</Label>
        <Divider />
      </ExampleBlock>

      <ExampleBlock>
        <Label>Custom color (brand.dark)</Label>
        <Divider $color={brand.dark} />
      </ExampleBlock>

      <ExampleBlock>
        <Label>Custom color (text.muted)</Label>
        <Divider $color={text.muted} />
      </ExampleBlock>

      <CodeBlock
        code={`import { Divider } from "@atlas-int/ui";

// Default — uses borderToken.divider
<Divider />

// Custom color
<Divider $color={brand.dark} />`}
      />
    </PreviewSection>
  );
};

export default DividerSection;
